/* eslint-disable indent */
import styled from 'styled-components';

import { COLORS } from 'theme';

export const SIZES = {
  MEDIUM: 'medium',
  LARGE: 'large',
};

export const StyledSectionTitle = styled.h4`
  font-size: ${({ theme }) => theme.fontSize.h4};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  margin: ${({ theme }) => `${theme.spacing.m1} 0`};

  ${({ $size, theme }) =>
    $size === SIZES.LARGE &&
    `
      margin-top: ${theme.spacing.m1};
      margin-bottom: ${theme.spacing.s4};
  `}
`;

export const StyledSectionSubtitle = styled.p`
  color: ${COLORS.black50};
  font-size: ${({ theme }) => theme.fontSize.body2};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  line-height: ${({ theme }) => theme.lineHeight.body2};
  margin-block: ${({ theme }) => theme.spacing.s2};
`;
